import styled from 'styled-components'
import Link from 'react-router-dom/Link'
import { Form } from 'formik'

const Wrapper = styled.div`
  border-radius: 5px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  z-index: 9;
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '0')};
`

const FlexWrap = styled.div`
  height: ${props => (props.height ? props.height : 'calc(100vh - 40px)')};
  display: flex;
  flex-direction: column;
  justify-content: ${props => (props.justifyContent ? props.justifyContent : 'flex-start')};
  align-items: ${props => (props.alignItems ? props.alignItems : 'flex-start')};
  overflow: ${props => (props.overflow ? props.overflow : 'initial')};
  margin: ${props => (props.viewMargin ? props.viewMargin : '0px')};
  padding: ${props => (props.viewPadding ? props.viewPadding : '0px')};
`
const StyledLink = styled(Link)`
  color: #078489;
  font-size: 16px;
  line-height: 1.56;
`
const FlexWrapper = styled.div`
  display: flex;
  flex-direction: ${props => (props.direction ? props.direction : 'column')};
  justify-content: ${props => (props.justifyContent ? props.justifyContent : 'flex-start')};
  align-items: ${props => (props.alignItems ? props.alignItems : 'flex-start')};
  margin: ${props => (props.viewMargin ? props.viewMargin : '0px')};
  padding: ${props => (props.viewPadding ? props.viewPadding : '0px')};
  flex-basis: ${props => (props.flexBasis ? props.flexBasis : 'auto')};
  height: ${props => (props.height ? props.height : 'auto')};
  width: ${props => (props.width ? props.width : '100%')};
  min-width: ${props => (props.minWidth ? props.minWidth : 'auto')};
  border: ${props => (props.border ? props.border : 'none')};
  background: ${props => (props.backgroundColor ? props.backgroundColor : 'transparent')};
  flex-wrap: ${props => (props.flexWrap ? props.flexWrap : 'nowrap')};
  border-radius: ${props => (props.borderRadius ? props.borderRadius : '0')};
  position: ${props => (props.position ? props.position : 'static')};
`

const XCMText = styled.p`
  font-family: Overpass;
  font-size: 24px;
  line-height: 1.54;
  color: ${props => (props.color ? props.color : '#124b5f')};
  text-align: center;
`
const XLText = styled.h1`
  font-family: Chivo;
  font-size: 32px;
  line-height: 1.19;
  color: #124b5f;
  text-align: center;
  text-transform: ${props => (props.textTransform ? props.textTransform : 'none')};
`
const XXXLText = styled.p`
  font-family: Chivo;
  font-size: 20px;
  line-height: 1.2;
  color: #ffffff;
  text-transform: capitalize;
`
const XXLText = styled.p`
  font-size: 18px;
  font-family: ${props => (props.font ? props.font : 'Overpass')};
  font-weight: ${props => (props.fontWeight ? props.fontWeight : 'normal')};
  line-height: 1.33;
  color: ${props => (props.color ? props.color : '#078489')};
  text-align: ${props => (props.textAlign ? props.textAlign : 'center')};
  ${props =>
    props.smallMobile &&
    `
    @media(max-width: 370px){
      font-size: 15px;
    }
  `};
`
const DefaultText = styled.p`
  font-family: Overpass;
  font-weight: ${props => (props.fontWeight ? props.fontWeight : 'normal')};
  font-size: 16px;
  line-height: ${props => (props.lineHeight ? props.lineHeight : 1.5)};
  color: ${props => (props.color ? props.color : '#078489')};
  text-transform: ${props => (props.textTransform ? props.textTransform : 'none')};
  padding: ${props => (props.padding ? props.padding : '0')};
  text-align: ${props => (props.textAlign ? props.textAlign : 'left')};
`
const XLMText = styled.p`
  font-size: 15px;
  font-weight: ${props => (props.fontWeight ? props.fontWeight : 'normal')};
  line-height: 1.33;
  color: ${props => (props.color ? props.color : '#124b5f')};
  overflow-wrap: ${props => (props.overflowWrap ? props.overflowWrap : 'break-word')};
`
const XMText = styled.p`
  font-size: 14px;
  line-height: 1.57;
  color: ${props => (props.color ? props.color : '#124b5f')};
  padding: ${props => (props.padding ? props.padding : '0')};
  font-weight: ${props => (props.fontWeight ? props.fontWeight : 'normal')};
  min-height: ${props => (props.minHeight ? props.minHeight : '0px')};
`
const XMTDFext = styled.p`
  font-size: 13px;
  line-height: 1.57;
  color: ${props => (props.color ? props.color : '#124b5f')};
  padding: ${props => (props.padding ? props.padding : '0')};
  font-weight: ${props => (props.fontWeight ? props.fontWeight : 'normal')};
`

const XXXMText = styled.p`
  font-size: 13px;
  line-height: 1.54;
  font-weight: ${props => (props.fontWeight ? props.fontWeight : 'normal')};
  color: ${props => (props.color ? props.color : '#9a9a9a')};
  padding: ${props => (props.padding ? props.padding : '0')};
`
const XXMText = styled.p`
  font-size: 11px;
  line-height: 1.45;
  color: ${props => (props.color ? props.color : '#078489')};
`
const XXXXMText = styled.p`
  font-size: 10px;
  line-height: 1.7;
  text-align: left;
  color: ${props => (props.color ? props.color : '#9a9a9a')};
`
const SmallestText = styled.p`
  font-size: 9px;
  line-height: 1.56;
  color: ${props => (props.color ? props.color : '#078489')};
`
const XLMMText = styled.p`
  font-size: 12px;
  line-height: 1.5;
  color: ${props => (props.color ? props.color : '#078489')};
  padding: ${props => (props.padding ? props.padding : '0')};
  /* text-transform: capitalize; */
  text-decoration: ${props => (props.textDecoration ? props.textDecoration : 'none')};
  font-style: ${props => (props.fontStyle ? props.fontStyle : 'normal')};
`
const Arrow = styled.div`
  width: 11px;
  height: 11px;
  border-left: 2px solid ${props => (props.color ? props.color : '#fff')};
  border-bottom: 2px solid ${props => (props.color ? props.color : '#fff')};
  transform: rotate(${props => (props.rotate ? props.rotate : -45)}deg);
  margin: ${props => (props.margin ? props.margin : '0px')};
`
const FormikForm = styled(Form)`
  height: ${props => (props.height ? props.height : '100%')};
  display: flex;
  flex-direction: column;
  justify-content: ${props => (props.justifyContent ? props.justifyContent : 'flex-start')};
  width: 100%;
`
const Circle = styled.div`
  width: ${props => (props.size ? props.size : '16px')};
  height: ${props => (props.size ? props.size : '16px')};
  border-radius: 50%;
  background-color: ${props => (props.backgroundColor ? props.backgroundColor : '#ffffff')};
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${props => (props.border ? props.border : 'none')};
  margin: ${props => (props.margin ? props.margin : '0')};
  box-shadow: ${props => (props.boxShadow ? props.boxShadow : 'none')};
  min-width: ${props => (props.minWidth ? props.minWidth : 'auto')};
  border: 1px solid ${props => (props.borderColor ? props.borderColor : 'transparent')};
`
const Tabber = styled.div`
  display: flex;
  flex-wrap: wrap;
  & > a {
    flex-basis: 33.33%;
    text-align: center;
  }
  padding-bottom: 8px;
`
const Tab = styled(Link)`
  color: ${props => (props.selected ? '#124b5f' : '#a0b7bf')};
  font-size: 18px;
  line-height: 1.56px;
  position: relative;
  padding-bottom: 20px;
  cursor: pointer;
  &:after {
    content: '';
    position: absolute;
    height: 3px;
    background-color: ${props => (props.selected ? '#124b5f' : '#dddddd')};
    border-radius: 20px;
    width: 100%;
    bottom: 0px;
    left: 0px;
  }
  @media (max-width: 372px) {
    font-size: 13px;
  }
  @media (min-width: 373px) {
    font-size: 17px;
  }
`
const Error = styled.p`
  position: absolute;
  left: 0px;
  top: 35px;
  color: #f44336;
  font-size: 12px;
  ${props =>
    props.response &&
    `
  position: static;
  color: #f44336;
  font-size: 16px;
  text-align: center;
  text-transform: capitalize;
  padding-top: 6px;
  `};
  ${props =>
    props.styleType === 'select' &&
    `
    left: 24px;
    top: 50px;
  `};
`
const Shape = styled.div`
  padding: ${props => (props.padding ? props.padding : '8px 14px')};
  background-color: ${props => (props.backgroundColor ? props.backgroundColor : 'rgba(18, 75, 95, 0.06)')};
  box-shadow: ${props => (props.boxShadow ? props.boxShadow : 'none')};
  display: ${props => (props.display ? props.display : 'flex')};
  align-items: center;
  justify-content: ${props => (props.justifyContent ? props.justifyContent : 'space-between')};
  border: ${props => (props.border ? props.border : 'none')};
  border-radius: ${props => (props.borderRadius ? props.borderRadius : '20px')};
  margin: ${props => (props.margin ? props.margin : '0')};
  width: ${props => props.width || 'auto'};
  min-width: ${props => (props.minWidth ? props.minWidth : 'auto')};

  & > svg {
    margin-right: 4px;
  }
  ${props =>
    props.position === 'absolute' &&
    `
  position: absolute;
  top: -10px;
  z-index: 9;
  left: calc(50% - 33px);
  `};
  ${props =>
    props.selected &&
    `
        background: #f2ad9f !important;
    // color: #fff;
    // border: 1px solid #fff;
  `};
`

const StyledFlex = styled(FlexWrapper)`
  border-bottom: 0.5px solid #dcdcdc;
`
const Div = styled.div`
  position: relative;
`
const BgImage = styled.div`
  background-image: url('${props => props.src}');
  max-width: 100%;
  height:${props => (props.height ? props.height : '149px')};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: 5px 5px 0 0;
  @media(min-width: 600px) and (max-width: 769px){
    height: 550px;
  }
  @media(min-width: 400px) and (max-width: 599px){
    height: 300px;
  }
  @media(max-width: 399px){
    height: 250px;
  }
  @media(min-width: 770px){
    height: 600px;

  }
`
const Overlay = styled.div`
  position: absolute;
  background: ${props => (props.backgroundColor ? props.backgroundColor : 'rgba(83, 89, 91, 0.71)')};
  width: 100%;
  height: 100%;
  z-index: 99;
  top: 0;
  left: 0;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  & > h3 {
    color: ${props => (props.color ? props.color : '#fff')};
    font-size: ${props => (props.showMessage ? 18 : 24)}px;
    width: ${props => (props.width ? props.width : 'unset')};
    text-align: center;
  }
`
const OverlayChild = styled.div`
  filter: ${props => (props.filter ? props.filter : 'blur(2px) grayscale(20%)')};
`
const CardWrap = styled.div`
  & > div {
    border-radius: 0;
    border-bottom: ${props => (props.borderBottom ? props.borderBottom : 'none')};
    &:first-child {
      border-radius: 5px 5px 0 0;
    }
    &:last-child {
      border-radius: 0 0 5px 5px;
    }
  }
`
const BackgroundImage = styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  -webkit-filter: blur(8px); /* Safari 6.0 - 9.0 */
  filter: blur(8px);
`
const TextOverflow = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: ${props => (props.maxWidth ? props.maxWidth : '120px')};
`
const FilteredImage = styled.img`
  width: 30px;
  height: 30px;
  position: absolute;
  right: 16px;
  top: 14px;
  -webkit-filter: blur(4px); /* Safari 6.0 - 9.0 */
  filter: blur(4px);
  border-radius: 50%;
`
const ImageWrap = styled.div`
  border-radius: 50%;
  min-width: 30px;
  height: 30px;
  // border: 1px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #fff;
  & > img:nth-child(2) {
    max-width: 30px;
    height: 100%;
    width: auto;
    object-fit: cover;
    border-radius: 0;
    margin: 0 auto;
    position: relative;
  }
`
const ProductViewWrapper = styled(FlexWrapper)`
  & > div {
    width: calc(50% - 5px);
    & > div {
      width: 100%;
    }
  }
`
export {
  ImageWrap,
  FilteredImage,
  CardWrap,
  TextOverflow,
  XCMText,
  OverlayChild,
  Overlay,
  BgImage,
  Wrapper,
  Div,
  FlexWrapper,
  FlexWrap,
  XLText,
  DefaultText,
  XMText,
  StyledLink,
  XXLText,
  Arrow,
  FormikForm,
  XXXLText,
  XXMText,
  XMTDFext,
  XXXMText,
  Circle,
  XXXXMText,
  XLMText,
  XLMMText,
  Shape,
  Tabber,
  Tab,
  SmallestText,
  StyledFlex,
  BackgroundImage,
  ProductViewWrapper,
  Error
}



// WEBPACK FOOTER //
// ./src/components/StyledComponents.js